import { DictMessageSource } from '@core/types'

export const createMessageSource = (
    rows: any,
    languages: string[]
): DictMessageSource => {
    const res: Record<string, any> = {}

    languages.forEach(l => {
        res[l] = {}
    })
    rows.forEach((row: any) => {
        // @ts-ignore
        // TODO check that texts contain all keys - crosscheck with keys file
        // https://www.youtrack.software/issue/BOXY-60

        languages.forEach(l => {
            const key = row.key
            const text = row[l]
            if (!text)
                throw new Error(`Missing language ${l} text for key ${key}`)

            res[l][key] = row[l]
        })
    })

    return res
}
